//
// WarningEvent.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";
import "../../events/PortableEvent";
import "./Warning";

var WarningEvent = createModule("commons::WarningEvent", ["commons::PortableEvent"], ClosetObject, [
    {
        GENERIC: 10056,
        CLEAR_WARNINGS: 10057,
    },
    ,
    ,
    {
        warnings: [1],
    },
    ,
    {
        _create: [4],
    },
    ,
]);
export default WarningEvent;
